import axios from 'axios';

const apiBase = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

if (!apiBase && process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line no-console
  console.error(
    '[api] REACT_APP_API_URL is missing — requests go to the React dev server, not Flask. ' +
      'Set it in frontend/.env or .env.development.local (e.g. http://127.0.0.1:5000/api) and restart npm start.'
  );
}

// Create axios instance
const api = axios.create({
  baseURL: apiBase || undefined,
  headers: {
    "ngrok-skip-browser-warning": "69420",
  }
});



// Request interceptor to add token to all requests
api.interceptors.request.use(
  (config) => {
    const user = localStorage.getItem('user');
    if (user) {
      const token=JSON.parse(user)
      config.headers['Authorization'] = `Bearer ${token.token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle token errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Check if the error is related to authentication
    if (error.response && error.response.status === 401) {
      console.log(error)
      // Clear all auth-related data from storage
      // localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // Dispatch logout action if using Redux
      // store.dispatch({ type: 'LOGOUT' });
      
      // Redirect to login page
      window.location.href = '/login';
      
      // You can also show a notification
      // toast.error('Your session has expired. Please login again.');
    }
    
    return Promise.reject(error);
  }
);

export default api;